import { includedWorkerDocumentSchema } from "@clipboard-health/contract-worker-app-bff";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createDocumentRequestSchema = z.object({
  data: z.object({
    attributes: z.object({
      name: z.string(),
      requirementId: z.string(),
      workerUserId: z.string(),
      expiry: z.string().datetime().optional(),
      fileStorageRootFolder: z.string(),
      fileStorageFileKey: z.string(),
      subType: z.string().optional(),
    }),
  }),
});

const createDocumentResponseSchema = z.object({
  data: includedWorkerDocumentSchema,
});

export type CreateDocumentRequest = z.infer<typeof createDocumentRequestSchema>;
export type CreateDocumentResponse = z.infer<typeof createDocumentResponseSchema>;

export function useCreateDocument(
  options: UseMutationOptions<CreateDocumentResponse, AxiosError, CreateDocumentRequest> = {}
): UseMutationResult<CreateDocumentResponse, AxiosError, CreateDocumentRequest> {
  return useMutation({
    mutationFn: async (request: CreateDocumentRequest) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/documents`,
        data: request,
        responseSchema: createDocumentResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_DOCUMENT_FAILURE,
    },
    ...options,
  });
}
